import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useStateList from "./hooks/useStateList";

const StateList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData,
}) => {
  const stateListData = useStateList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );
  return (
    <div class="container container-fluid popup">
      <ButtonsSection ctaButtons={stateListData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {stateListData.screen_title} -{" "}
          <span className="heading-cod">{stateListData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={stateListData.formFields}
        dropdownValues={stateListData.dropdownValues}
        paramsData={stateListData.paramsData}
        updataParamData={stateListData.updateParamData}
      />
      <ButtonsSection ctaButtons={stateListData.ctaButtons} />
      <DisplayTable
        data={stateListData.data}
        parmKey={stateListData.parmKey}
        menuOptions={stateListData.menuOptions}
        tableHeaders={stateListData.columnDef}
        setRowData={stateListData.setRowData}
        selectedPriceSchedules={stateListData.selectedRows}
        setSelectedPriceSchedules={stateListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={stateListData.first}
          rows={stateListData.rows}
          totalRecords={stateListData.totalRecords}
          currentPage={stateListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={stateListData.onPageChange}
        />
      </div>
      {stateListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={stateListData.isConfirmationModalOpen}
          onRequestClose={stateListData.closeConfirmationModal}
          onBack={stateListData.closeConfirmationModal}
          onSave={stateListData.deleteStateList}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={stateListData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default StateList;
